// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/map-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/unicon-front-view.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/map-1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.11 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
  padding-right: 8rem;
  padding-left: 8rem;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-bottom-12 {
  bottom: -3rem;
}
.-left-\\[100\\%\\] {
  left: -100%;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-24 {
  bottom: 6rem;
}
.left-0 {
  left: 0px;
}
.left-3 {
  left: 0.75rem;
}
.right-0 {
  right: 0px;
}
.right-10 {
  right: 2.5rem;
}
.right-5 {
  right: 1.25rem;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-3 {
  top: 0.75rem;
}
.top-5 {
  top: 1.25rem;
}
.-z-10 {
  z-index: -10;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.z-\\[90\\] {
  z-index: 90;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.m-1 {
  margin: 0.25rem;
}
.m-auto {
  margin: auto;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-24 {
  margin-bottom: 6rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-10 {
  margin-right: 2.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-20 {
  margin-right: 5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-\\[26px\\] {
  margin-right: 26px;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.hidden {
  display: none;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2\\/3 {
  height: 66.666667%;
}
.h-2\\/4 {
  height: 50%;
}
.h-36 {
  height: 9rem;
}
.h-60 {
  height: 15rem;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[23px\\] {
  height: 23px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[394px\\] {
  height: 394px;
}
.h-\\[53px\\] {
  height: 53px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[calc\\(100vh-230px\\)\\] {
  height: calc(100vh - 230px);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[100vh\\] {
  max-height: 100vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.min-h-\\[140px\\] {
  min-height: 140px;
}
.min-h-\\[90px\\] {
  min-height: 90px;
}
.min-h-full {
  min-height: 100%;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2\\/12 {
  width: 16.666667%;
}
.w-2\\/4 {
  width: 50%;
}
.w-3\\/12 {
  width: 25%;
}
.w-3\\/4 {
  width: 75%;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[21\\%\\] {
  width: 21%;
}
.w-\\[23px\\] {
  width: 23px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[31\\%\\] {
  width: 31%;
}
.w-\\[32\\%\\] {
  width: 32%;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[45\\%\\] {
  width: 45%;
}
.w-\\[48\\%\\] {
  width: 48%;
}
.w-\\[49\\%\\] {
  width: 49%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[53px\\] {
  width: 53px;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-\\[66\\%\\] {
  width: 66%;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[99\\%\\] {
  width: 99%;
}
.w-full {
  width: 100%;
}
.min-w-52 {
  min-width: 13rem;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-y-5 {
  --tw-translate-y: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-8 {
  --tw-translate-x: 2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.border-\\[\\#abb8c3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(171 184 195 / var(--tw-border-opacity));
}
.border-\\[\\#ccc\\] {
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity));
}
.border-bd {
  --tw-border-opacity: 1;
  border-color: rgb(206 212 218 / var(--tw-border-opacity));
}
.border-grey {
  --tw-border-opacity: 1;
  border-color: rgb(68 68 68 / var(--tw-border-opacity));
}
.border-hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 206 135 / var(--tw-border-opacity));
}
.border-logo {
  --tw-border-opacity: 1;
  border-color: rgb(14 14 75 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-b-logo {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(14 14 75 / var(--tw-border-opacity));
}
.border-t-\\[\\#3A375E\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(58 55 94 / var(--tw-border-opacity));
}
.border-t-white {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.bg-\\[\\#0E0E4B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 14 75 / var(--tw-bg-opacity));
}
.bg-\\[\\#222\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(34 34 34 / var(--tw-bg-opacity));
}
.bg-\\[\\#3a3c82\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(58 60 130 / var(--tw-bg-opacity));
}
.bg-\\[\\#464897\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(70 72 151 / var(--tw-bg-opacity));
}
.bg-\\[\\#e5f3ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 243 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff5\\] {
  background-color: #fff5;
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  background-color: rgba(0,0,0,0.5);
}
.bg-accordion {
  background-color: rgba(64,64,64,0.10);
}
.bg-accordion_content {
  --tw-bg-opacity: 1;
  background-color: rgb(252 252 252 / var(--tw-bg-opacity));
}
.bg-bd {
  --tw-bg-opacity: 1;
  background-color: rgb(206 212 218 / var(--tw-bg-opacity));
}
.bg-bg-calc {
  --tw-bg-opacity: 1;
  background-color: rgb(245 247 248 / var(--tw-bg-opacity));
}
.bg-grey {
  --tw-bg-opacity: 1;
  background-color: rgb(68 68 68 / var(--tw-bg-opacity));
}
.bg-hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 206 135 / var(--tw-bg-opacity));
}
.bg-logo {
  --tw-bg-opacity: 1;
  background-color: rgb(14 14 75 / var(--tw-bg-opacity));
}
.bg-logo-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(6 147 227 / var(--tw-bg-opacity));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(14 14 75 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-16 {
  padding: 4rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-\\[2px\\] {
  padding: 2px;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-40 {
  padding-left: 10rem;
  padding-right: 10rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-28 {
  padding-bottom: 7rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-72 {
  padding-top: 18rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-normal {
  line-height: 1.5;
}
.text-\\[\\#00314C\\] {
  --tw-text-opacity: 1;
  color: rgb(0 49 76 / var(--tw-text-opacity));
}
.text-\\[\\#007AFF\\] {
  --tw-text-opacity: 1;
  color: rgb(0 122 255 / var(--tw-text-opacity));
}
.text-\\[\\#0E0E4B\\] {
  --tw-text-opacity: 1;
  color: rgb(14 14 75 / var(--tw-text-opacity));
}
.text-\\[\\#3A375E\\] {
  --tw-text-opacity: 1;
  color: rgb(58 55 94 / var(--tw-text-opacity));
}
.text-\\[red\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-grey {
  --tw-text-opacity: 1;
  color: rgb(68 68 68 / var(--tw-text-opacity));
}
.text-hover {
  --tw-text-opacity: 1;
  color: rgb(0 206 135 / var(--tw-text-opacity));
}
.text-logo {
  --tw-text-opacity: 1;
  color: rgb(14 14 75 / var(--tw-text-opacity));
}
.text-logo-secondary {
  --tw-text-opacity: 1;
  color: rgb(6 147 227 / var(--tw-text-opacity));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(14 14 75 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.underline {
  text-decoration-line: underline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-100 {
  transition-delay: 100ms;
}
.delay-75 {
  transition-delay: 75ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}


html {
    height: 100%;
    scroll-behavior: smooth;
    font-size: 16px;
}

body {
    height: 100%;
    font-family: 'Montserrat', sans-serif;
    overflow-x: hidden;
}

.container {
    max-width: 1600px;
    width: 90%;
    margin: 0 auto;
    padding: 0;
}

.grayscale-image {
    filter: grayscale(100%);
}

#root {
    min-height: 100vh;
    overflow: hidden;
}

#root > div:nth-child(1) {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.home div video {
    object-fit: cover;
}

@media screen and (max-width: 1204px){
    .home div {
        height: 100%!important;
    }
}

.content {
    flex-grow: 1;
}

input, textarea {
    outline-color: #0059ff!important;
}
input:focus-visible, textarea:focus-visible {
    border: 2px solid #0059ff!important;
}
input[type="file"] {
    display: none;
}
.home_news {
    width: 100%;
    height: 45vh!important;
    object-fit: cover;
}
.connection {
    padding-top: 150px;
    padding-bottom: 150px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

.custom-file-upload {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 8px;
    cursor: pointer;
    color: #95a4a6;
    padding: 6px 12px;
}
.file-preview {
    margin: 0 10px;
}


::-webkit-scrollbar {
    width: 15px;
    border-radius: 50px !important;
}

::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    border-radius: 9px;
    background-clip: content-box;
    background-color: #fff;
}
::-webkit-scrollbar-track {
    background-color: #0E0E4B;
}


.bolimlar ::-webkit-scrollbar {
    display: none;
}

.bolimlar ::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    border-radius: 9px;
    background-clip: content-box;
    background-color: transparent;
}
.bolimlar ::-webkit-scrollbar-track {
    background-color: #ccc;
}

.bolimlarDetail div:nth-child(even) {
    background-color: #ced4da;
}

.svg {
    width: 100%;
    animation: fill 0.5s ease forwards 9s;
}

.svg svg {
    width: 100%;
    animation: fill2 0.5s ease forwards 9s;
}

.svg path:nth-child(1) {
    stroke-dasharray: 226;
    stroke-dashoffset: 226;
    animation: lineAnim 2s ease forwards 7.7s;
}
.svg path:nth-child(2) {
    stroke-dasharray: 260;
    stroke-dashoffset: 260;
    animation: lineAnim 2s ease forwards 8s;
}
.svg path:nth-child(3) {
    stroke-dasharray: 112;
    stroke-dashoffset: 112;
    animation: lineAnim 2s ease forwards 0.9s;
}
.svg path:nth-child(4) {
    stroke-dasharray: 222;
    stroke-dashoffset: 222;
    animation: lineAnim 2s ease forwards 1.2s;
}
.svg path:nth-child(5) {
    stroke-dasharray: 232;
    stroke-dashoffset: 232;
    animation: lineAnim 2s ease forwards 1.5s;
}
.svg path:nth-child(6) {
    stroke-dasharray: 260;
    stroke-dashoffset: 260;
    animation: lineAnim 2s ease forwards 1.8s;
}
.svg path:nth-child(7) {
    stroke-dasharray: 34;
    stroke-dashoffset: 34;
    animation: lineAnim 2s ease forwards 2.1s;
}
.svg svg path:nth-child(8) {
    stroke-dasharray: 226;
    stroke-dashoffset: 226;
    animation: lineAnim 2s ease forwards 4.5s;
}
.svg svg path:nth-child(9) {
    stroke-dasharray: 225;
    stroke-dashoffset: 225;
    animation: lineAnim 2s ease forwards 4.8s;
}
.svg path:nth-child(10) {
    stroke-dasharray: 266;
    stroke-dashoffset: 266;
    animation: lineAnim 2s ease forwards 4s;
}
.svg path:nth-child(11) {
    stroke-dasharray: 260;
    stroke-dashoffset: 260;
    animation: lineAnim 2s ease forwards 5.3s;
}
.svg path:nth-child(12) {
    stroke-dasharray: 112;
    stroke-dashoffset: 112;
    animation: lineAnim 2s ease forwards 5.6s;
}
.svg path:nth-child(13) {
    stroke-dasharray: 222;
    stroke-dashoffset: 222;
    animation: lineAnim 2s ease forwards 5.9s;
}
.svg path:nth-child(14) {
    stroke-dasharray: 232;
    stroke-dashoffset: 232;
    animation: lineAnim 2s ease forwards 6.2s;
}
.svg path:nth-child(15) {
    stroke-dasharray: 260;
    stroke-dashoffset: 260;
    animation: lineAnim 2s ease forwards 6.5s;
}
.svg path:nth-child(16) {
    stroke-dasharray: 34;
    stroke-dashoffset: 34;
    animation: lineAnim 2s ease forwards 6.8s;
}
.svg path:nth-child(17) {
    stroke-dasharray: 226;
    stroke-dashoffset: 226;
    animation: lineAnim 2s ease forwards 7.1s;
}
.svg path:nth-child(18) {
    stroke-dasharray: 225;
    stroke-dashoffset: 225;
    animation: lineAnim 2s ease forwards 7.4s;
}
@keyframes lineAnim {
    to {
        stroke-dashoffset: 0;
    }
}
@keyframes fill {
    from {
        fill: transparent;
    }
    to {
        fill: #3A3C82;
    }
}

@keyframes fill2 {
    from {
        fill: transparent;
    }
    to {
        fill: #F63030;
    }
}

.news-link {
    position: relative;
    transition: all 0.3s;
}

.news-link:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #0E0E4B;
    transition: 0.3s;
    z-index: 99;
}

.news-link:hover:after {
    width: 0;
}

.header-parent {
    background-color: #778da9;
}

.common__section {
    position: relative;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / cover;
    background-position: center 20%;
}

.common__section:after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(43, 57, 109, 0.65);
    z-index: 1;
    opacity: 0.7;
}

.common__section > h1 {
    position: relative;
    z-index: 40;
}

.card:hover {
    box-shadow: 0px 7.94708px 24px -2px rgba(0, 0, 0, 0.25);
}

header {
    height: 58px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07),
    0 1px 2px 0 rgba(0, 0, 0, 0.05);
    color: #212529;
}

.nav-area {
    display: flex;
    align-items: center;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    height: 58px;
}

.logo {
    text-decoration: none;
    font-size: 1.5rem;
    color: inherit;
    margin-right: 20px;
}

.menus {
    display: flex;
    list-style: none;
}

.menu-items {
    position: relative;
    font-size: 1.1rem;
}

.menu-items a {
    display: block;
    font-size: inherit;
    color: inherit;
    text-decoration: none;
}

.menu-items button {
    color: inherit;
    font-size: inherit;
    border: none;
    background-color: transparent;
    cursor: pointer;
    width: 100%;
}

.menu-items a,
.menu-items button {
    text-align: left;
    padding: 0.7rem 1rem;
}

.menu-items a:hover,
.menu-items button:hover {
    background: #0E0E4B;
    color: #fff;
}

.arrow::after {
    content: "";
    display: inline-block;
    margin-left: 0.28em;
    vertical-align: 0.09em;
    border-top: 0.42em solid;
    border-right: 0.32em solid transparent;
    border-left: 0.32em solid transparent;
}

.dropdown {
    position: absolute;
    left: auto;
    font-size: 0.875rem;
    z-index: 9999;
    min-width: 12rem;
    padding: 0.1rem 0;
    list-style: none;
    background-color: #fff;
    color: #3A375E;
    border-radius: 0.5rem;
    transition: all 0.3s;
}

.dropdown.show {
    display: block;
}

.dropdown.dropdown .submenu {
    position: absolute;
    left: 100% !important;
}

.menu-items .dropdown .menu-items .dropdown-submenu {
    left: 100% !important;
}

.menu-items .active {
    background: #0E0E4B;
    color: #fff;
}

.dropdown.dropdown-submenu.show {
    left: 100%;
    top: 0;
}

.logos {
    z-index: 999 !important;
}



/*preloader*/
.animated {
    transition: 1s all ease;
}

.preloader {
    width: 100%;
    height: 100vh;
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: #ffffff;
    overflow: hidden;
}

/* custom */

.preloader .inner {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #0E0E4B;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preloader .text {
    position: absolute;
    left: calc(50% + 260px);
    top: calc(50% - 35px);
    text-transform: uppercase;
    transform: translateX(-50%) !important;
    color: #fff;
    font-size: 5rem;
    line-height: 1;
    white-space: nowrap;
    display: flex;
    z-index: 2;
    font-family: 'Outfit';
    -webkit-user-select: none;
            user-select: none;
    -webkit-text-stroke-color: #ffffff;
    -webkit-text-stroke-width: 0.02em;
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    -moz-text-fill-color: transparent;
    background-repeat: no-repeat;
    transition: background-size 0.5s cubic-bezier(0.67, 0.01, 0.15, 0.98);
    background-image: linear-gradient(
            90deg,
            #ffffff 0%,
            #ffffff 50%,
            transparent 50.1%
    );
    background-position: 100% 100%;
    background-size: 100% 0%;
}

.preloader span {
    width: 490px;
}

.preloader span:nth-child(2) {
    -webkit-text-stroke-width: 0rem;
}

.mobile {
    display: none;
}

.hamBox {
    position: relative;
    width: 44px;
    height: 44px;
    cursor: pointer;
    border-radius: 50%;
    transition: 0.3s ease;
    padding: 2.4em;
}

.lineTop, .lineBottom {
    margin: 0 auto;
    position: absolute;
    display: block;
    width: 24px;
    height: 2px;
    border-radius: 10px;
    background: #0E0E4B;
    left: 0;
    right: 0;
    transform: rotate(0deg);
    transition: all 0.4s;
}

.lineTop {
    top: 2.2em;
}

.lineBottom {
    bottom: 2.2em;
}

.lineTop.spin {
    top: 2.35em;
    transform: rotate(135deg);
    background: #0E0E4B;
}

.lineBottom.spin {
    bottom: 2.35em;
    transform: rotate(225deg);
    background: #0E0E4B;
}

.news .swiper-slide,
.products .swiper-slide,
.news_details .swiper-slide {
    width: 40%;
}

.text_from_api {
    overflow-wrap: anywhere;
}


.unicon-info {
    position: relative;
}
/* button-Atrrangment */
.button-Atrrangment {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 20px;
    left: 190px !important;
}
.button-swiper {
    padding: 20px;
    background-color: #fff;
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.swiper-button-next,
.swiper-button-prev,
.swiper-pagination {
    top: unset !important;
    left: unset !important;
    right: unset !important;
    bottom: unset !important;
    width: auto !important;
    position: unset !important;
}
.swiper-button-prev::after,
.swiper-button-next::after {
    color: #0E0E4B;
    font-size: 1.5rem !important;
}
.swiper-pagination-bullet-active,
.swiper-pagination-bullet {
    width: 12px !important;
    height: 12px !important;
    background-color: #0E0E4B !important;
}

#edit-share-btn {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.25rem;
    background-color: #fff;
    cursor: pointer;
    border: 2px solid #56b8f5;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    display: none;
    align-items: center;
    justify-content: center;
    transition: color 0.2s, background-color .2s ease-in-out;
}
#edit-share-btn:hover {
    background-color: #56b8f5;
}
#edit-share-btn:hover svg path {
    fill: #fff;
}
#edit-share-btn svg {
    pointer-events: none;
}
#read-text-btn {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.25rem;
    background-color: #fff;
    cursor: pointer;
    border: 2px solid #56b8f5;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    display: none;
    align-items: center;
    justify-content: center;
    transition: color 0.2s, background-color .2s ease-in-out;
}
#read-text-btn:hover {
    background-color: #56b8f5;
}
#read-text-btn:hover svg path {
    fill: #fff;
}
#read-text-btn svg {
    pointer-events: none;
}
.btnEntrance {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: btnEntrance;
}
@keyframes btnEntrance {
    0% {
        opacity: 0;
        transform: scale3d(.3, .3, .3);
    }
    100% {
        opacity: 1;
    }
}



@media screen and (max-width: 1690px) {
    .nav_link {
        font-size: .8rem !important;
        padding: 10px;
    }
}
@media screen and (max-width: 1401px) {
    .nav_link {
        /* font-size: .6rem !important; */
        padding: 5px !important;
    }
}

@media screen and (max-width: 1200px) {
    .container {
        padding-left: 4rem;
        padding-right: 4rem;
    }
    .desktop {
        display: none;
    }
    .mobile {
        display: block;
    }
    .menus {
        flex-direction: column;
    }
    .hamBox {
        width: 30px;
        height: 30px;
        padding: 2.4rem 0;
    }
    .dropdown {
        position: relative;
        /* top: 90%; */
        /* left: 0;
        right: 0; */
        min-width: 80%;
    }
}

@media screen and (max-width: 768px) {
    .news .swiper-slide,
    .products .swiper-slide,
    .news_details .swiper-slide {
        width: 48%;
    }
    .servis-card {
        width: 100%!important;
    }
}

@media screen and (max-width: 867px){
    .container {
        padding-left: 2rem;
        padding-right: 2rem;
    }
    
    .c-col{
        width: 100% !important;
    }
}

@media screen and (max-width: 640px) {
    .container {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .card {
        width: 100% !important;
    }
    .trim {
        width: 100% !important;
    }
    .card_footer {
        width: 100% !important;
    }
    .products {
        width: 100% !important;
    }
}

@media screen and (max-width: 425px) {
    body #ym-informer {
        left: 0 !important;
        width: 425px !important;
    }
    footer .box-child {
        width: 100% !important;
    }
    .news .swiper-slide,
    .products .swiper-slide,
    .news_details .swiper-slide {
        width: 100%;
    }
    .preloader .text {
        left: calc(50% + 350px);
    }
    .common_title {
        font-size: 1rem !important;
        line-height: 1rem !important;
    }
    .fotos {
        width: 100% !important;
    }
    .products {
        width: 100% !important;
    }
    .news .products {
        width: 100% !important;
    }
    /*.dropdown {*/
    /*    top: 90% !important;*/
    /*    left: 0;*/
    /*    right: 0;*/
    /*    min-width: 80%;*/
    /*}*/
    .dropdown .menu-items {
        font-size: 1rem;
    }
    .products .swiper-pagination-bullet:nth-child(even) {
        display: none;
    }
    .language {
        right: 2.5rem !important;
    }
}

@media screen and (max-width: 375px) {
    body #ym-informer {
        left: 0 !important;
        width: 375px !important;
    }
    .left_nav {
        width: 85% !important;
    }
}

.transparent {
    background: transparent;
}

.partners .swiper-button-prev,
.partners .swiper-button-next,
.products .swiper-button-prev,
.products .swiper-button-next {
    display: none;
}

.products .swiper-pagination {
    bottom: -5px !important;
}

.partners .mySwiper {
    overflow: initial;
    padding-top: 40px !important;
    padding-bottom: 40px !important;
}

.products .mySwiper {
    overflow: hidden;
    padding-bottom: 20px !important;
}
.input:focus-visible {
    outline: none !important;
    border: none !important;
}

.contact {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / cover;
}

.products .swiper,
.news .swiper {
    padding: 30px 0 !important;
}

/* *::selection {
    display: none;
} */

.news_details .swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
}

.news_details .swiper-slide {
    background-position: center;
    background-size: cover;
}

.news_details .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
}

.partners .img:last-child {
    margin-right: 50px;
}

.partners .img_reverse:first-child {
    margin-left: 70px;
}

.videorolik {
    position: relative;
    display: flex;
    height: 500px;
    background-color: #f2f2f2;
    /* background-image: url(../../../../assets/bgVd.mp4); */
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 4px;
    overflow: hidden;
    padding: 40px 60px;
}
.videorolik--tarix{
    border-radius: 0!important;
}
.videorolik__link {
    position: absolute;
    top: -77px;
    left: -20px;
    display: block;
    padding: 90px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.3);
    opacity: .8;
    animation: pulse 1.8s linear infinite;
}
.videorolik__link:hover {
    opacity: 1;
}
.round1 {
    padding: 80px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.5);
    animation: pulse 1.8s linear infinite;
}
.round2 {
    padding: 60px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.9);
    animation: pulse 1.8s linear infinite;
}
.videorolik__title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 2.2rem;
    line-height: 1.4;
    color: #FFFFFF;
    margin-left: auto;
    z-index: 1;
}


.video-wrap {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /*display: none;*/
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, .6);
    padding: 20px;
    z-index: 99;
}
.video-wrap__modal {
    max-width: 1000px;
    width: 100%;
    max-height: 500px;
}


.videoUnicon {
    transform: translate(-60px, -210px);
}
.videoUnicon--tarix {
    transform: translate(-60px, -130px);
}


@keyframes pulse {
    0% {
        transform: scale(.5);
        opacity: 0.6;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: scale(1.2);
        opacity: 0.6;
    }
}

@media screen and (max-width: 1451px){
    .videoUnicon {
        height: 100%;
        transform: translate(-60px, -40px);
    }
}

.animation{
    width: 300px;
    position: relative;
    animation: mymove 20s linear infinite;
}
@keyframes mymove {
    from {left: 0%;}
    to {left: 100%;}
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:bottom-7::after {
  content: var(--tw-content);
  bottom: 1.75rem;
}
.after\\:left-\\[12\\.5\\%\\]::after {
  content: var(--tw-content);
  left: 12.5%;
}
.after\\:left-\\[25\\%\\]::after {
  content: var(--tw-content);
  left: 25%;
}
.after\\:left-\\[25\\.2\\%\\]::after {
  content: var(--tw-content);
  left: 25.2%;
}
.after\\:h-\\[3px\\]::after {
  content: var(--tw-content);
  height: 3px;
}
.after\\:w-1\\/2::after {
  content: var(--tw-content);
  width: 50%;
}
.after\\:w-1\\/4::after {
  content: var(--tw-content);
  width: 25%;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:bg-\\[\\#3a3c82\\]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(58 60 130 / var(--tw-bg-opacity));
}
.last\\:mr-0:last-child {
  margin-right: 0px;
}
.odd\\:bg-bd:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(206 212 218 / var(--tw-bg-opacity));
}
.hover\\:-translate-y-2:hover {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:rounded:hover {
  border-radius: 0.25rem;
}
.hover\\:border-hover:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 206 135 / var(--tw-border-opacity));
}
.hover\\:bg-\\[\\#00ce87\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 206 135 / var(--tw-bg-opacity));
}
.hover\\:bg-bd:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(206 212 218 / var(--tw-bg-opacity));
}
.hover\\:bg-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 206 135 / var(--tw-bg-opacity));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:text-hover:hover {
  --tw-text-opacity: 1;
  color: rgb(0 206 135 / var(--tw-text-opacity));
}
.hover\\:text-logo:hover {
  --tw-text-opacity: 1;
  color: rgb(14 14 75 / var(--tw-text-opacity));
}
.hover\\:text-logo-secondary:hover {
  --tw-text-opacity: 1;
  color: rgb(6 147 227 / var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.disabled\\:opacity-25:disabled {
  opacity: 0.25;
}
@media (max-width: 375px) {

  .xm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (max-width: 425px) {

  .xs\\:bottom-10 {
    bottom: 2.5rem;
  }

  .xs\\:right-4 {
    right: 1rem;
  }

  .xs\\:order-1 {
    order: 1;
  }

  .xs\\:mt-3 {
    margin-top: 0.75rem;
  }

  .xs\\:mt-4 {
    margin-top: 1rem;
  }

  .xs\\:w-1\\/4 {
    width: 25%;
  }

  .xs\\:w-\\[150px\\] {
    width: 150px;
  }

  .xs\\:w-\\[600px\\] {
    width: 600px;
  }

  .xs\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .xs\\:w-\\[900px\\] {
    width: 900px;
  }

  .xs\\:w-full {
    width: 100%;
  }

  .xs\\:w-screen {
    width: 100vw;
  }

  .xs\\:flex-col {
    flex-direction: column;
  }

  .xs\\:flex-wrap {
    flex-wrap: wrap;
  }

  .xs\\:justify-center {
    justify-content: center;
  }

  .xs\\:gap-3 {
    gap: 0.75rem;
  }

  .xs\\:gap-5 {
    gap: 1.25rem;
  }

  .xs\\:p-3 {
    padding: 0.75rem;
  }

  .xs\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .xs\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .xs\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .xs\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .xs\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .xs\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .xs\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .xs\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .xs\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (max-width: 640px) {

  .sm\\:order-2 {
    order: 2;
  }

  .sm\\:w-\\[150px\\] {
    width: 150px;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:gap-1 {
    gap: 0.25rem;
  }
}
@media (max-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:right-12 {
    right: 3rem;
  }

  .md\\:top-3 {
    top: 0.75rem;
  }

  .md\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .md\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .md\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .md\\:mb-7 {
    margin-bottom: 1.75rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-2 {
    margin-top: 0.5rem;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-1\\/2 {
    height: 50%;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-\\[32\\%\\] {
    width: 32%;
  }

  .md\\:w-\\[350px\\] {
    width: 350px;
  }

  .md\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-wrap {
    flex-wrap: wrap;
  }

  .md\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-1 {
    gap: 0.25rem;
  }

  .md\\:gap-12 {
    gap: 3rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:object-cover {
    object-fit: cover;
  }

  .md\\:p-1 {
    padding: 0.25rem;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:pl-9 {
    padding-left: 2.25rem;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (max-width: 1024px) {

  .lg\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-3\\/4 {
    height: 75%;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:border-0 {
    border-width: 0px;
  }

  .lg\\:bg-bg-calc {
    --tw-bg-opacity: 1;
    background-color: rgb(245 247 248 / var(--tw-bg-opacity));
  }

  .lg\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .lg\\:pl-0 {
    padding-left: 0px;
  }

  .lg\\:pt-28 {
    padding-top: 7rem;
  }

  .lg\\:pt-5 {
    padding-top: 1.25rem;
  }

  .lg\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (max-width: 1304px) {

  .xl\\:relative {
    position: relative;
  }

  .xl\\:mt-10 {
    margin-top: 2.5rem;
  }

  .xl\\:h-auto {
    height: auto;
  }

  .xl\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .xl\\:w-\\[48\\%\\] {
    width: 48%;
  }

  .xl\\:gap-7 {
    gap: 1.75rem;
  }

  .xl\\:p-8 {
    padding: 2rem;
  }

  .xl\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
}
@media (max-width: 1630px) {

  .xl2\\:w-full {
    width: 100%;
  }

  .xl2\\:pt-1 {
    padding-top: 0.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA,WAAoB;EAApB,mBAAoB;EAApB;AAAoB;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;AAKnB;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,yDAA8C;IAC9C,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,uCAAuC;AAC3C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,uCAAuC;AAC3C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yCAAyC;AAC7C;AACA;IACI;QACI,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,4EAA0E;IAC1E,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,YAAY;IACZ;mCAC+B;IAC/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,MAAM;AACV;;AAEA;IACI,uBAAuB;AAC3B;;;;AAIA,YAAY;AACZ;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,WAAW;;AAEX;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,sCAAsC;IACtC,WAAW;IACX,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,qBAAqB;IACrB,yBAAiB;YAAjB,iBAAiB;IACjB,kCAAkC;IAClC,iCAAiC;IACjC,oCAAoC;IACpC,6BAA6B;IAC7B,iCAAiC;IACjC,4BAA4B;IAC5B,qEAAqE;IACrE;;;;;KAKC;IACD,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;AACtB;AACA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;;IAGI,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;;IAEI,cAAc;IACd,4BAA4B;AAChC;AACA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wDAAwD;AAC5D;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wDAAwD;AAC5D;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;AACA;IACI;QACI,UAAU;QACV,8BAA8B;IAClC;IACA;QACI,UAAU;IACd;AACJ;;;;AAIA;IACI;QACI,2BAA2B;QAC3B,aAAa;IACjB;AACJ;AACA;IACI;QACI,iCAAiC;QACjC,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,cAAc;QACd;mBACW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI;;;QAGI,UAAU;IACd;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;;;QAGI,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,IAAI;IACJ;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,4EAA8D;AAClE;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,wDAAwD;IACxD,sBAAsB;IACtB,kCAAkC;IAClC,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,WAAW;IACX,qCAAqC;AACzC;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;AACzC;AACA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,aAAa;IACb,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;;AAGA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;;;AAGA;IACI;QACI,oBAAoB;QACpB,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kCAAkC;IACtC;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;AACzC;AACA;IACI,MAAM,QAAQ,CAAC;IACf,IAAI,UAAU,CAAC;AACnB;AA98BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA,sBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,0BA+8BA;EA/8BA,kBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA;AA+8BA;AA/8BA;EAAA,kBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,yBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,kBA+8BA;EA/8BA,kBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA;AA+8BA;AA/8BA;EAAA,sBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,kBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,kBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,kBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,kBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,oBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,oBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,oBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,oBA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA;AA+8BA;AA/8BA;EAAA;AA+8BA;AA/8BA;EAAA,gDA+8BA;EA/8BA,6DA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,gFA+8BA;EA/8BA,oGA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,8BA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA,2GA+8BA;EA/8BA,yGA+8BA;EA/8BA;AA+8BA;AA/8BA;EAAA;AA+8BA;AA/8BA;;EAAA;IAAA,kBA+8BA;IA/8BA;EA+8BA;AAAA;AA/8BA;;EAAA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,oBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,oBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,kBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,iBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,eA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,eA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,mBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,kBA+8BA;IA/8BA;EA+8BA;AAAA;AA/8BA;;EAAA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;AAAA;AA/8BA;;EAAA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,iBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,qBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,oBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,kBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,oBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,mBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,iBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,iBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,mBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,kBA+8BA;IA/8BA;EA+8BA;AAAA;AA/8BA;;EAAA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,kBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA,kBA+8BA;IA/8BA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,kBA+8BA;IA/8BA;EA+8BA;AAAA;AA/8BA;;EAAA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;;EA/8BA;IAAA,oBA+8BA;IA/8BA;EA+8BA;AAAA;AA/8BA;;EAAA;IAAA;EA+8BA;;EA/8BA;IAAA;EA+8BA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Outfit&display=swap');\n\n\nhtml {\n    height: 100%;\n    scroll-behavior: smooth;\n    font-size: 16px;\n}\n\nbody {\n    height: 100%;\n    font-family: 'Montserrat', sans-serif;\n    overflow-x: hidden;\n}\n\n.container {\n    max-width: 1600px;\n    width: 90%;\n    margin: 0 auto;\n    padding: 0;\n}\n\n.grayscale-image {\n    filter: grayscale(100%);\n}\n\n#root {\n    min-height: 100vh;\n    overflow: hidden;\n}\n\n#root > div:nth-child(1) {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.home div video {\n    object-fit: cover;\n}\n\n@media screen and (max-width: 1204px){\n    .home div {\n        height: 100%!important;\n    }\n}\n\n.content {\n    flex-grow: 1;\n}\n\ninput, textarea {\n    outline-color: #0059ff!important;\n}\ninput:focus-visible, textarea:focus-visible {\n    border: 2px solid #0059ff!important;\n}\ninput[type=\"file\"] {\n    display: none;\n}\n.home_news {\n    width: 100%;\n    height: 45vh!important;\n    object-fit: cover;\n}\n.connection {\n    padding-top: 150px;\n    padding-bottom: 150px;\n    background-image: url(../src/assets/map-1.png);\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n\n.custom-file-upload {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    cursor: pointer;\n    color: #95a4a6;\n    padding: 6px 12px;\n}\n.file-preview {\n    margin: 0 10px;\n}\n\n\n::-webkit-scrollbar {\n    width: 15px;\n    border-radius: 50px !important;\n}\n\n::-webkit-scrollbar-thumb {\n    border: 3px solid transparent;\n    border-radius: 9px;\n    background-clip: content-box;\n    background-color: #fff;\n}\n::-webkit-scrollbar-track {\n    background-color: #0E0E4B;\n}\n\n\n.bolimlar ::-webkit-scrollbar {\n    display: none;\n}\n\n.bolimlar ::-webkit-scrollbar-thumb {\n    border: 3px solid transparent;\n    border-radius: 9px;\n    background-clip: content-box;\n    background-color: transparent;\n}\n.bolimlar ::-webkit-scrollbar-track {\n    background-color: #ccc;\n}\n\n.bolimlarDetail div:nth-child(even) {\n    background-color: #ced4da;\n}\n\n.svg {\n    width: 100%;\n    animation: fill 0.5s ease forwards 9s;\n}\n\n.svg svg {\n    width: 100%;\n    animation: fill2 0.5s ease forwards 9s;\n}\n\n.svg path:nth-child(1) {\n    stroke-dasharray: 226;\n    stroke-dashoffset: 226;\n    animation: lineAnim 2s ease forwards 7.7s;\n}\n.svg path:nth-child(2) {\n    stroke-dasharray: 260;\n    stroke-dashoffset: 260;\n    animation: lineAnim 2s ease forwards 8s;\n}\n.svg path:nth-child(3) {\n    stroke-dasharray: 112;\n    stroke-dashoffset: 112;\n    animation: lineAnim 2s ease forwards 0.9s;\n}\n.svg path:nth-child(4) {\n    stroke-dasharray: 222;\n    stroke-dashoffset: 222;\n    animation: lineAnim 2s ease forwards 1.2s;\n}\n.svg path:nth-child(5) {\n    stroke-dasharray: 232;\n    stroke-dashoffset: 232;\n    animation: lineAnim 2s ease forwards 1.5s;\n}\n.svg path:nth-child(6) {\n    stroke-dasharray: 260;\n    stroke-dashoffset: 260;\n    animation: lineAnim 2s ease forwards 1.8s;\n}\n.svg path:nth-child(7) {\n    stroke-dasharray: 34;\n    stroke-dashoffset: 34;\n    animation: lineAnim 2s ease forwards 2.1s;\n}\n.svg svg path:nth-child(8) {\n    stroke-dasharray: 226;\n    stroke-dashoffset: 226;\n    animation: lineAnim 2s ease forwards 4.5s;\n}\n.svg svg path:nth-child(9) {\n    stroke-dasharray: 225;\n    stroke-dashoffset: 225;\n    animation: lineAnim 2s ease forwards 4.8s;\n}\n.svg path:nth-child(10) {\n    stroke-dasharray: 266;\n    stroke-dashoffset: 266;\n    animation: lineAnim 2s ease forwards 4s;\n}\n.svg path:nth-child(11) {\n    stroke-dasharray: 260;\n    stroke-dashoffset: 260;\n    animation: lineAnim 2s ease forwards 5.3s;\n}\n.svg path:nth-child(12) {\n    stroke-dasharray: 112;\n    stroke-dashoffset: 112;\n    animation: lineAnim 2s ease forwards 5.6s;\n}\n.svg path:nth-child(13) {\n    stroke-dasharray: 222;\n    stroke-dashoffset: 222;\n    animation: lineAnim 2s ease forwards 5.9s;\n}\n.svg path:nth-child(14) {\n    stroke-dasharray: 232;\n    stroke-dashoffset: 232;\n    animation: lineAnim 2s ease forwards 6.2s;\n}\n.svg path:nth-child(15) {\n    stroke-dasharray: 260;\n    stroke-dashoffset: 260;\n    animation: lineAnim 2s ease forwards 6.5s;\n}\n.svg path:nth-child(16) {\n    stroke-dasharray: 34;\n    stroke-dashoffset: 34;\n    animation: lineAnim 2s ease forwards 6.8s;\n}\n.svg path:nth-child(17) {\n    stroke-dasharray: 226;\n    stroke-dashoffset: 226;\n    animation: lineAnim 2s ease forwards 7.1s;\n}\n.svg path:nth-child(18) {\n    stroke-dasharray: 225;\n    stroke-dashoffset: 225;\n    animation: lineAnim 2s ease forwards 7.4s;\n}\n@keyframes lineAnim {\n    to {\n        stroke-dashoffset: 0;\n    }\n}\n@keyframes fill {\n    from {\n        fill: transparent;\n    }\n    to {\n        fill: #3A3C82;\n    }\n}\n\n@keyframes fill2 {\n    from {\n        fill: transparent;\n    }\n    to {\n        fill: #F63030;\n    }\n}\n\n.news-link {\n    position: relative;\n    transition: all 0.3s;\n}\n\n.news-link:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: #0E0E4B;\n    transition: 0.3s;\n    z-index: 99;\n}\n\n.news-link:hover:after {\n    width: 0;\n}\n\n.header-parent {\n    background-color: #778da9;\n}\n\n.common__section {\n    position: relative;\n    background: url(\"./assets/unicon-front-view.jpg\") no-repeat center / cover;\n    background-position: center 20%;\n}\n\n.common__section:after {\n    content: '';\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(43, 57, 109, 0.65);\n    z-index: 1;\n    opacity: 0.7;\n}\n\n.common__section > h1 {\n    position: relative;\n    z-index: 40;\n}\n\n.card:hover {\n    box-shadow: 0px 7.94708px 24px -2px rgba(0, 0, 0, 0.25);\n}\n\nheader {\n    height: 58px;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07),\n    0 1px 2px 0 rgba(0, 0, 0, 0.05);\n    color: #212529;\n}\n\n.nav-area {\n    display: flex;\n    align-items: center;\n    max-width: 100%;\n    margin: 0 auto;\n    padding: 0 20px;\n    height: 58px;\n}\n\n.logo {\n    text-decoration: none;\n    font-size: 1.5rem;\n    color: inherit;\n    margin-right: 20px;\n}\n\n.menus {\n    display: flex;\n    list-style: none;\n}\n\n.menu-items {\n    position: relative;\n    font-size: 1.1rem;\n}\n\n.menu-items a {\n    display: block;\n    font-size: inherit;\n    color: inherit;\n    text-decoration: none;\n}\n\n.menu-items button {\n    color: inherit;\n    font-size: inherit;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    width: 100%;\n}\n\n.menu-items a,\n.menu-items button {\n    text-align: left;\n    padding: 0.7rem 1rem;\n}\n\n.menu-items a:hover,\n.menu-items button:hover {\n    background: #0E0E4B;\n    color: #fff;\n}\n\n.arrow::after {\n    content: \"\";\n    display: inline-block;\n    margin-left: 0.28em;\n    vertical-align: 0.09em;\n    border-top: 0.42em solid;\n    border-right: 0.32em solid transparent;\n    border-left: 0.32em solid transparent;\n}\n\n.dropdown {\n    position: absolute;\n    left: auto;\n    font-size: 0.875rem;\n    z-index: 9999;\n    min-width: 12rem;\n    padding: 0.1rem 0;\n    list-style: none;\n    background-color: #fff;\n    color: #3A375E;\n    border-radius: 0.5rem;\n    transition: all 0.3s;\n}\n\n.dropdown.show {\n    display: block;\n}\n\n.dropdown.dropdown .submenu {\n    position: absolute;\n    left: 100% !important;\n}\n\n.menu-items .dropdown .menu-items .dropdown-submenu {\n    left: 100% !important;\n}\n\n.menu-items .active {\n    background: #0E0E4B;\n    color: #fff;\n}\n\n.dropdown.dropdown-submenu.show {\n    left: 100%;\n    top: 0;\n}\n\n.logos {\n    z-index: 999 !important;\n}\n\n\n\n/*preloader*/\n.animated {\n    transition: 1s all ease;\n}\n\n.preloader {\n    width: 100%;\n    height: 100vh;\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    z-index: 9999;\n    background: #ffffff;\n    overflow: hidden;\n}\n\n/* custom */\n\n.preloader .inner {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: #0E0E4B;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.preloader .text {\n    position: absolute;\n    left: calc(50% + 260px);\n    top: calc(50% - 35px);\n    text-transform: uppercase;\n    transform: translateX(-50%) !important;\n    color: #fff;\n    font-size: 5rem;\n    line-height: 1;\n    white-space: nowrap;\n    display: flex;\n    z-index: 2;\n    font-family: 'Outfit';\n    user-select: none;\n    -webkit-text-stroke-color: #ffffff;\n    -webkit-text-stroke-width: 0.02em;\n    -webkit-text-fill-color: transparent;\n    -webkit-background-clip: text;\n    -moz-text-fill-color: transparent;\n    background-repeat: no-repeat;\n    transition: background-size 0.5s cubic-bezier(0.67, 0.01, 0.15, 0.98);\n    background-image: linear-gradient(\n            90deg,\n            #ffffff 0%,\n            #ffffff 50%,\n            transparent 50.1%\n    );\n    background-position: 100% 100%;\n    background-size: 100% 0%;\n}\n\n.preloader span {\n    width: 490px;\n}\n\n.preloader span:nth-child(2) {\n    -webkit-text-stroke-width: 0rem;\n}\n\n.mobile {\n    display: none;\n}\n\n.hamBox {\n    position: relative;\n    width: 44px;\n    height: 44px;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: 0.3s ease;\n    padding: 2.4em;\n}\n\n.lineTop, .lineBottom {\n    margin: 0 auto;\n    position: absolute;\n    display: block;\n    width: 24px;\n    height: 2px;\n    border-radius: 10px;\n    background: #0E0E4B;\n    left: 0;\n    right: 0;\n    transform: rotate(0deg);\n    transition: all 0.4s;\n}\n\n.lineTop {\n    top: 2.2em;\n}\n\n.lineBottom {\n    bottom: 2.2em;\n}\n\n.lineTop.spin {\n    top: 2.35em;\n    transform: rotate(135deg);\n    background: #0E0E4B;\n}\n\n.lineBottom.spin {\n    bottom: 2.35em;\n    transform: rotate(225deg);\n    background: #0E0E4B;\n}\n\n.news .swiper-slide,\n.products .swiper-slide,\n.news_details .swiper-slide {\n    width: 40%;\n}\n\n.text_from_api {\n    overflow-wrap: anywhere;\n}\n\n\n.unicon-info {\n    position: relative;\n}\n/* button-Atrrangment */\n.button-Atrrangment {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    bottom: 20px;\n    left: 190px !important;\n}\n.button-swiper {\n    padding: 20px;\n    background-color: #fff;\n    width: 180px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.swiper-button-next,\n.swiper-button-prev,\n.swiper-pagination {\n    top: unset !important;\n    left: unset !important;\n    right: unset !important;\n    bottom: unset !important;\n    width: auto !important;\n    position: unset !important;\n}\n.swiper-button-prev::after,\n.swiper-button-next::after {\n    color: #0E0E4B;\n    font-size: 1.5rem !important;\n}\n.swiper-pagination-bullet-active,\n.swiper-pagination-bullet {\n    width: 12px !important;\n    height: 12px !important;\n    background-color: #0E0E4B !important;\n}\n\n#edit-share-btn {\n    width: 2.5rem;\n    height: 2.5rem;\n    font-size: 1.25rem;\n    background-color: #fff;\n    cursor: pointer;\n    border: 2px solid #56b8f5;\n    border-radius: 50%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 99;\n    display: none;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s, background-color .2s ease-in-out;\n}\n#edit-share-btn:hover {\n    background-color: #56b8f5;\n}\n#edit-share-btn:hover svg path {\n    fill: #fff;\n}\n#edit-share-btn svg {\n    pointer-events: none;\n}\n#read-text-btn {\n    width: 2.5rem;\n    height: 2.5rem;\n    font-size: 1.25rem;\n    background-color: #fff;\n    cursor: pointer;\n    border: 2px solid #56b8f5;\n    border-radius: 50%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 99;\n    display: none;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s, background-color .2s ease-in-out;\n}\n#read-text-btn:hover {\n    background-color: #56b8f5;\n}\n#read-text-btn:hover svg path {\n    fill: #fff;\n}\n#read-text-btn svg {\n    pointer-events: none;\n}\n.btnEntrance {\n    animation-duration: .2s;\n    animation-fill-mode: both;\n    animation-name: btnEntrance;\n}\n@keyframes btnEntrance {\n    0% {\n        opacity: 0;\n        transform: scale3d(.3, .3, .3);\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n\n\n@media screen and (max-width: 1690px) {\n    .nav_link {\n        font-size: .8rem !important;\n        padding: 10px;\n    }\n}\n@media screen and (max-width: 1401px) {\n    .nav_link {\n        /* font-size: .6rem !important; */\n        padding: 5px !important;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .container {\n        padding-left: 4rem;\n        padding-right: 4rem;\n    }\n    .desktop {\n        display: none;\n    }\n    .mobile {\n        display: block;\n    }\n    .menus {\n        flex-direction: column;\n    }\n    .hamBox {\n        width: 30px;\n        height: 30px;\n        padding: 2.4rem 0;\n    }\n    .dropdown {\n        position: relative;\n        /* top: 90%; */\n        /* left: 0;\n        right: 0; */\n        min-width: 80%;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .news .swiper-slide,\n    .products .swiper-slide,\n    .news_details .swiper-slide {\n        width: 48%;\n    }\n    .servis-card {\n        width: 100%!important;\n    }\n}\n\n@media screen and (max-width: 867px){\n    .container {\n        padding-left: 2rem;\n        padding-right: 2rem;\n    }\n    \n    .c-col{\n        width: 100% !important;\n    }\n}\n\n@media screen and (max-width: 640px) {\n    .container {\n        padding-left: 1rem;\n        padding-right: 1rem;\n    }\n    .card {\n        width: 100% !important;\n    }\n    .trim {\n        width: 100% !important;\n    }\n    .card_footer {\n        width: 100% !important;\n    }\n    .products {\n        width: 100% !important;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    body #ym-informer {\n        left: 0 !important;\n        width: 425px !important;\n    }\n    footer .box-child {\n        width: 100% !important;\n    }\n    .news .swiper-slide,\n    .products .swiper-slide,\n    .news_details .swiper-slide {\n        width: 100%;\n    }\n    .preloader .text {\n        left: calc(50% + 350px);\n    }\n    .common_title {\n        font-size: 1rem !important;\n        line-height: 1rem !important;\n    }\n    .fotos {\n        width: 100% !important;\n    }\n    .products {\n        width: 100% !important;\n    }\n    .news .products {\n        width: 100% !important;\n    }\n    /*.dropdown {*/\n    /*    top: 90% !important;*/\n    /*    left: 0;*/\n    /*    right: 0;*/\n    /*    min-width: 80%;*/\n    /*}*/\n    .dropdown .menu-items {\n        font-size: 1rem;\n    }\n    .products .swiper-pagination-bullet:nth-child(even) {\n        display: none;\n    }\n    .language {\n        right: 2.5rem !important;\n    }\n}\n\n@media screen and (max-width: 375px) {\n    body #ym-informer {\n        left: 0 !important;\n        width: 375px !important;\n    }\n    .left_nav {\n        width: 85% !important;\n    }\n}\n\n.transparent {\n    background: transparent;\n}\n\n.partners .swiper-button-prev,\n.partners .swiper-button-next,\n.products .swiper-button-prev,\n.products .swiper-button-next {\n    display: none;\n}\n\n.products .swiper-pagination {\n    bottom: -5px !important;\n}\n\n.partners .mySwiper {\n    overflow: initial;\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n}\n\n.products .mySwiper {\n    overflow: hidden;\n    padding-bottom: 20px !important;\n}\n.input:focus-visible {\n    outline: none !important;\n    border: none !important;\n}\n\n.contact {\n    background: url(\"./assets/map-1.png\") no-repeat center / cover;\n}\n\n.products .swiper,\n.news .swiper {\n    padding: 30px 0 !important;\n}\n\n/* *::selection {\n    display: none;\n} */\n\n.news_details .swiper {\n    width: 100%;\n    padding-top: 50px;\n    padding-bottom: 50px;\n}\n\n.news_details .swiper-slide {\n    background-position: center;\n    background-size: cover;\n}\n\n.news_details .swiper-slide img {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.partners .img:last-child {\n    margin-right: 50px;\n}\n\n.partners .img_reverse:first-child {\n    margin-left: 70px;\n}\n\n.videorolik {\n    position: relative;\n    display: flex;\n    height: 500px;\n    background-color: #f2f2f2;\n    /* background-image: url(../../../../assets/bgVd.mp4); */\n    background-size: cover;\n    background-position: center center;\n    background-repeat: no-repeat;\n    border-radius: 4px;\n    overflow: hidden;\n    padding: 40px 60px;\n}\n.videorolik--tarix{\n    border-radius: 0!important;\n}\n.videorolik__link {\n    position: absolute;\n    top: -77px;\n    left: -20px;\n    display: block;\n    padding: 90px;\n    border-radius: 50%;\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    opacity: .8;\n    animation: pulse 1.8s linear infinite;\n}\n.videorolik__link:hover {\n    opacity: 1;\n}\n.round1 {\n    padding: 80px;\n    border-radius: 50%;\n    border: 3px solid rgba(255, 255, 255, 0.5);\n    animation: pulse 1.8s linear infinite;\n}\n.round2 {\n    padding: 60px;\n    border-radius: 50%;\n    border: 3px solid rgba(255, 255, 255, 0.9);\n    animation: pulse 1.8s linear infinite;\n}\n.videorolik__title {\n    font-family: 'Montserrat', sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 2.2rem;\n    line-height: 1.4;\n    color: #FFFFFF;\n    margin-left: auto;\n    z-index: 1;\n}\n\n\n.video-wrap {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    /*display: none;*/\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, .6);\n    padding: 20px;\n    z-index: 99;\n}\n.video-wrap__modal {\n    max-width: 1000px;\n    width: 100%;\n    max-height: 500px;\n}\n\n\n.videoUnicon {\n    transform: translate(-60px, -210px);\n}\n.videoUnicon--tarix {\n    transform: translate(-60px, -130px);\n}\n\n\n@keyframes pulse {\n    0% {\n        transform: scale(.5);\n        opacity: 0.6;\n    }\n    50% {\n        opacity: 1;\n    }\n    100% {\n        transform: scale(1.2);\n        opacity: 0.6;\n    }\n}\n\n@media screen and (max-width: 1451px){\n    .videoUnicon {\n        height: 100%;\n        transform: translate(-60px, -40px);\n    }\n}\n\n.animation{\n    width: 300px;\n    position: relative;\n    animation: mymove 20s linear infinite;\n}\n@keyframes mymove {\n    from {left: 0%;}\n    to {left: 100%;}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
